import { render, staticRenderFns } from "./balance_record_page.vue?vue&type=template&id=6a870649&scoped=true"
import script from "./balance_record_page.vue?vue&type=script&lang=js"
export * from "./balance_record_page.vue?vue&type=script&lang=js"
import style0 from "./balance_record_page.vue?vue&type=style&index=0&id=6a870649&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a870649",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a870649')) {
      api.createRecord('6a870649', component.options)
    } else {
      api.reload('6a870649', component.options)
    }
    module.hot.accept("./balance_record_page.vue?vue&type=template&id=6a870649&scoped=true", function () {
      api.rerender('6a870649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/balance_record_page.vue"
export default component.exports